import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-619cb964"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  style: {
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "end"
  }
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import tableComponent from './components/Table';
import { getAuthPlatFormAppLogPage } from '@/api/sys';
import usePagination from '@/hooks/usePagination';
import { tableDataSchemas } from './config';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);

    // loading效果
    const loading = ref(false);
    const {
      currentPage,
      total,
      pageSize,
      setPageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const getData = async () => {
      loading.value = true;
      const res = await getAuthPlatFormAppLogPage({
        currentPage: currentPage.value,
        pageSize: pageSize.value
      });
      setTotal(res.total);
      tableData.value = res.records;
      loading.value = false;
    };

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getData();
    };
    const handleChangeSize = e => {
      setPageSize(e);
      getData();
    };
    const router = useRouter();
    const handleInfo = row => {
      router.push(`/log/plat/${row.id}`);
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(tableComponent), {
          onInfo: handleInfo,
          tableData: tableData.value,
          loading: loading.value,
          schemas: _unref(tableDataSchemas),
          currentPage: _unref(currentPage),
          pageSize: _unref(pageSize)
        }, null, 8, ["tableData", "loading", "schemas", "currentPage", "pageSize"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleChangeSize,
          "page-sizes": [12, 24, 36],
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, sizes, prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      })]);
    };
  }
};